import { Component } from "@angular/core";
import { AuthService } from "../../core/services/auth.service";

@Component({
    selector: "app-unauthorized",
    templateUrl: "./unauthorized.component.html",
    styleUrls: ["./unauthorized.component.scss"],
    standalone: true,
})
export class UnauthorizedComponent {}
